<template>
  <div
    class="p-the-header-navi-profile-panel"
    :style="{ backgroundColor: colorCode }"
  >
    <div class="p-the-header-navi-profile-panel__icon">
      <IconUserImage :size="24" :is-loading="isLoading">
        <img v-if="userAvatar" :src="userAvatar" :alt="`${userName}`" />
      </IconUserImage>
    </div>
    <span class="p-the-header-navi-profile-panel__name" data-translate-skip>
      {{ userName }}
    </span>
    <button class="p-the-header-navi-profile-panel__logout" @click="logout">
      <IconBase
        :width="24"
        :height="24"
        view-box="0 0 24 24"
        icon-color="transparent"
      >
        <IconLogout icon-color="#ffffff" />
      </IconBase>
    </button>
  </div>
</template>

<script lang="ts">
import IconUserImage from "@/common/components/icons/IconUserImage.vue";
import IconBase from "@/common/components/atoms/IconBase.vue";
import IconLogout from "@/common/components/icons/IconLogout.vue";

import { Options, Vue } from "vue-class-component";

import commons from "@/common/store/modules/commons";

import { karteLogin } from "@/common/assets/js/karte/";
import LocalStorage from "@/general/utils/storage";
import AuthApi from "@/general/api/authApi";
import loginInfo from "@/general/store/modules/loginInfo";
import auth from "@/general/store/modules/auth";

@Options({
  components: {
    IconUserImage,
    IconBase,
    IconLogout
  }
})
export default class TheHeaderNaviProfilePanel extends Vue {
  ssoFlg = false;
  avatar = "";
  isLoading = true;

  get colorCode() {
    if (this.isGroupBudget) {
      return "#fc9014";
    }
    return commons?.colorCode;
  }

  get isGroupBudget() {
    return commons?.userInfo.groupBudgetMode;
  }

  get userName() {
    return commons.getNameFromUser(commons.userInfo);
  }

  get userAvatar() {
    //#59042対応によりセッション情報からavatarを取得するように修正
    //return commons.userInfo?.avatar;
    return this.avatar;
  }

  async logout() {
    karteLogin(false);

    await fetch(commons.LOGOUT_URL, { method: "POST" })
      .then(() => {
        window.sessionStorage.clear();
        // window.localStorage.clear();
        LocalStorage.removeAll();
        AuthApi.getLogout().catch((e) => {
          console.log(e);
        });
        auth.remove();
        if (this.ssoFlg) {
          // SSOログインの場合は行き止まりログアウトへ遷移
          window.location.href = "/logout/";
        } else {
          window.location.href =
            process.env.VUE_APP_API_DOMAIN + "/v1/top/login";
        }
      })
      .catch(() => {
        window.sessionStorage.clear();
        // window.localStorage.clear();
        LocalStorage.removeAll();
        AuthApi.getLogout().catch((e) => {
          console.log(e);
        });
        auth.remove();
        if (this.ssoFlg) {
          // SSOログインの場合は行き止まりログアウトへ遷移
          window.location.href = "/logout/";
        } else {
          window.location.href =
            process.env.VUE_APP_API_DOMAIN + "/v1/top/login";
        }
      });
  }

  //#59042対応によりセッション情報からavatarを取得するように修正
  async created() {
    this.ssoFlg = loginInfo.isSso;
    await AuthApi.getICSession()
      .then((result) => {
        const ic_session = JSON.parse(result);
        this.avatar = ic_session.avatar;
        this.isLoading = false;
      })
      .catch(() => {
        this.avatar = "";
        this.isLoading = false;
      });
  }
}
</script>

<style lang="scss" scoped>
.p-the-header-navi-profile-panel {
  display: flex;
  align-items: center;
  padding: rem(8) rem(48) rem(8) rem(16);
  position: relative;
  &__icon {
    width: rem(24);
    min-width: rem(24);
    margin-right: rem(12);
  }
  &__name {
    color: $common-white;
    font-size: rem(16);
    font-weight: bold;
    line-height: 1.6;
    word-spacing: normal
  }
  &__logout {
    width: rem(48);
    height: rem(48);
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    background: none;
  }
}
</style>
